<template>
  <div :class="`${$style.pageWrapper}`">
    <div :class="` ${$style.actRecords}`">
      <DropdownMenu style="">
        <DropdownItem v-model="gameId" :options="gameList"></DropdownItem>
      </DropdownMenu>
      <div :class="$style.listHeader">
        <div :class="$style.col1">奖品名称</div>
        <div :class="$style.col2">礼包码</div>
        <div :class="$style.col3">中奖时间</div>
      </div>
      <List
        v-model="loading"
        :finished="finished"
        :finished-text="recordList.length ? '没有更多了' : '暂无数据'"
        @load="onLoad"
      >
        <Cell v-for="item in recordList" :key="item.id">
          <div :class="` ${$style.content}`">
            <p :class="`${$style.col1} ${$style.colItem}`">
              {{ item.prizeName }}
            </p>
            <div :class="`${$style.col2} ${$style.colItem} ${$style.colGift}`">
              <p v-if="item.prizeType == 0" style="flex:1">{{ item.cdk || '礼包码生成错误' }}</p>
              <p v-if="item.prizeType != 0" style="flex:1">-</p>
              <Button
                v-if="item.cdk"
                :class="`${$style.nextStep} copySubscribeCdk`"
                @click="onCopy"
                :data-clipboard-text="item.cdk"
              >
                复制
              </Button>
            </div>
            <p :class="`${$style.col3} ${$style.colItem}`">
              {{ item.createTime }}
            </p>
          </div>
        </Cell>
      </List>
      <!-- <div v-if="recordList.length === 0" :class="$style.empty">
        <p>当前游戏暂无领取记录~</p>
        <p>可选择其他游戏查询</p>
      </div> -->
    </div>
  </div>
</template>

<script>
import { inithandler } from "@/bridge/jsBridge";
import Clipboard from "clipboard";
import { CDN_URL_1 } from "@/config";
import { onGoBack, setPageTitle } from "@/bridge/AppJsBridge";
import { getGamesListApi, getTurntableRecordApi } from "@/apis/wxActivity";
import { Button, DropdownMenu, DropdownItem, List, Cell } from "vant";
import { getCookie, pageLoseTips } from "@/libs/utils";

const initPage = {
  size: 20,
  current: 1,
};
export default {
  name: "",
  components: {
    Button,
    DropdownMenu,
    DropdownItem,
    List,
    Cell,
  },
  data() {
    return {
      gameId: null,
      cdnLink: CDN_URL_1,
      pageTitle: "领取记录",
      giftInfo: null,
      cookie: null,
      isLoading: false,
      gameList: [],
      recordList: [],
      loading: false,
      finished: true,
      pageParams: initPage,
    };
  },
  computed: {
    compActivityId () {
      return this.$route.query ? this.$route.query.id : ''
    }
  },
  watch: {
    gameId: function (value, oldVal) {
      this.pageParams = initPage;
      this.onChangeGameOption({ value, isForce: true });
    },
  },
  created() {
    // 页面初始化
    try {
      inithandler();
    } catch (error) {
      console.log(" error", error);
    }
    this.initPageData();
  },
  activated() {
    setPageTitle(this.pageTitle);
  },
  mounted() {
    this.copy = new Clipboard(".copySubscribeCdk");
  },
  methods: {
    onLoad() {
      this.onChangeGameOption({value: this.gameId})
    },
    // 获取cookie、缓存等携带的用户信息数据
    async initPageData() {
      setPageTitle(this.pageTitle);
      const { history } = this.$router;
      const { params } = history.current;
      if (params.gameId) {
        this.gameId = Number(params.gameId);
        this.getGameList();
      } else {
        pageLoseTips(this.$toast);
      }
    },

    // 获取游戏列表
    async getGameList() {
      const data = await getGamesListApi({ activityId: this.compActivityId });
      this.gameList = data.data.map((item) => {
        return {
          text: item.appName,
          value: item.activityGameId
        }
      });
    },

    // 下拉刷新
    async onRefresh() {
      await this.initPageData();
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    onChangeGameOption(props) {
      const { value, isForce } = props;
      let params = {
        activityGameId: value,
        ...this.pageParams,
      };
      getTurntableRecordApi(params).then((res) => {
        const { data } = res;
        if (isForce) {
          this.recordList = data.list;
        }else{
          this.recordList = [...this.recordList, ...data.list];
        }
        this.loading = false;
        if (data.list < this.pageParams.size) {
          this.finished = true;
        }else{
          this.finished = false;
          this.pageParams = {
            ...this.pageParams,
            current: this.pageParams.current + 1,
          };
        }
      });
    },

    // 关闭页面
    closePage() {
      onGoBack();
    },
    onCopy() {
      this.copy.on("success", () => {
        this.$toast("复制成功");
      });
    },
  },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
<style lang="scss" module>
.pageWrapper {
  width: 100%;
  min-height: 100vh;
  max-width: 375px;
  text-align: center;
  margin: auto;
  background: #f6f6f6;
  overflow: auto;
  .actRecords {
    background: #fff;
    width: 95%;
    min-height: 100vh;
    margin: 4px auto 0;
  }
  .empty {
    text-align: center;
    margin-top: 50px;
    color: #fc5f5e;
    line-height: 28px;
  }
  //   ::van-dropdown-menu__bar{

  //   }
  .content {
    display: flex;
    justify-content: space-around;
    align-items: center;

    .colItem {
      font-size: 13px;
      font-weight: 400;
      text-align: left;
      color: #999999;
      line-height: 13px;
    }
    .colGift {
      display: flex;
      align-items: center;
      justify-content: center;
      word-break: break-all;
    }
    .nextStep {
      padding: 0 4px;
      border: none;
      font-size: 12px;
      font-weight: 400;
      text-decoration: underline;
      text-align: left;
      color: #ffa547;
    }
    .time {
      height: 12px;
      font-size: 12px;
      font-weight: 400;
      text-align: left;
      color: #6879ad;
    }
  }

  .col1 {
    flex: 1;
  }
  .col2 {
    flex: 1;
    text-align: center !important;
  }
  .col3 {
    flex: 1;
    text-align: right !important;
  }
  .listHeader {
    display: flex;
    justify-content: space-between;
    padding: 14px 14px 2px;
    > div {
      font-size: 15px;
      font-weight: 500;
      text-align: left;
      color: #666666;
    }
  }
}
</style>
